import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";
import "@/App.css";

export default function SiteLayout() {
    const location = useLocation();

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        window.__lenis?.scrollTo(0, { immediate: true });
    }, [location.pathname]);

    useEffect(() => {
        if (!location.hash) return;
        const timer = window.setTimeout(() => scrollToId(location.hash), 120);
        return () => window.clearTimeout(timer);
    }, [location.pathname, location.hash]);

    return (
        <div className="App grain">
            <Navbar />
            <Outlet />
            <Footer />
        </div>
    );
}
